import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex: 1;
`

export const SubTitleContainer = styled.div``

export const Title = styled.div`
  padding-bottom: 20px;
  font-size: 16px;
  font-weight: 700;
`

export const SubTitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  text-align: center;
`

export const ButtonContainer = styled.div`
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0px;
`

export const ButtonBack = styled.div`
  color: #2d749c;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
`

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #c6016b;
  color: white;
  font-weight: bold;
  border: none;
  padding: 14px 22px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
`

export const DatePickerWrapper = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: center;
  padding: 20px 0px;
`

export const Message = styled.p`
  width: 80%;
  margin: 4px 0;
  font-size: 13px;
  line-height: 1.4;
  text-align: center;
`
